import { render } from "./EmailPreviewModal.vue?vue&type=template&id=36a89ba0&scoped=true"
import script from "./EmailPreviewModal.vue?vue&type=script&lang=js"
export * from "./EmailPreviewModal.vue?vue&type=script&lang=js"

import "./EmailPreviewModal.vue?vue&type=style&index=0&id=36a89ba0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a89ba0"]])

export default __exports__